import axios from 'axios';

export const getIP = async () =>
  await axios
    .get('https://api.ipify.org?format=json')
    .then(({ data }) => data && data.ip)
    .catch(() => {});

export const getLocationFromIP = async () =>
  await axios
    .get(`https://ipapi.co/json/`)
    .then(({ data }) => data)
    .catch(() => {});
